import Vue from 'vue'
import App from './App'
import router from './router/'
import store from './store'
import filter from './filter'
import Loading from '@/components/utils/Loading.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import './axios'
import AsyncComputed from 'vue-async-computed'
import { mixin as clickaway } from 'vue-clickaway'

Vue.use(AsyncComputed)
Vue.mixin(clickaway)

Vue.config.productionTip = false

Vue.component('loading', Loading)
Vue.component('date-picker', DatePicker)

require('@/assets/styles/app.scss')

new Vue({
	router,
	store,
	filter,
	render: h => h(App)
}).$mount('#app')
